import React, { useId, useState } from "react";
import { urlDelPortal } from "../helpers/zoco";
import cambiarIcon from "../assets/sidebar/cambiar.svg";
import chatIcon from "../assets/sidebar/chat.svg";
import { SidebarChevron, SidebarIcon } from "./SidebarIcon";

const IconoTienda = () => (
  <svg className="zr-stroke-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
    <path d="M2 7h20" />
    <path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7" />
  </svg>
);

// Tarjeta: mismo trazo que IconoTienda.
const IconoPagos = () => (
  <svg className="zr-stroke-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <line x1="2" y1="10" x2="22" y2="10" />
    <line x1="6" y1="15" x2="10" y2="15" />
  </svg>
);

/**
 * `/api/auth/autorizar` vive en la API de Zoco, que comparte origen con el portal: lee la cookie
 * del portal, emite un código de un solo uso para el producto y redirige. Por eso son `<a>` con
 * navegación completa y nunca links del router: solo así viaja la cookie del portal. El negocio
 * va en el pase para que el otro producto entre ya parado en él (Pagos no lo lleva: es del portal
 * y no se para en un negocio, igual que en productos.ts de Zoco).
 */
const opcionesPara = (negocio) => {
  const negocioParam = negocio?.id ? `&negocio=${negocio.id}` : "";
  return [
    {
      clave: "portal",
      etiqueta: (
        <>
          Volver al Portal <strong>ZOCO</strong>
        </>
      ),
      icono: <SidebarIcon src={cambiarIcon} width={24} />,
      href: urlDelPortal("/"),
    },
    {
      clave: "chat",
      etiqueta: "Zoco Chat",
      icono: <SidebarIcon src={chatIcon} width={22} />,
      href: urlDelPortal(`/api/auth/autorizar?producto=Chats${negocioParam}`),
    },
    {
      clave: "pdv",
      etiqueta: "Zoco PDV",
      icono: <IconoTienda />,
      href: urlDelPortal(`/api/auth/autorizar?producto=Pdv${negocioParam}`),
    },
    {
      clave: "pagos",
      etiqueta: "Zoco Pagos",
      icono: <IconoPagos />,
      href: urlDelPortal("/api/auth/autorizar?producto=pagos"),
    },
  ];
};

/**
 * El "Cambiar" de la barra lateral, igual que en ZocoPDV y ZOCO Chats: una fila desplegable en
 * línea (como los módulos) con los destinos. Solo se muestra en sesiones de Zoco: un login propio
 * de Tickets no tiene cuenta de Zoco detrás y el pase no tendría adónde llegar.
 */
const CambiarProducto = ({ negocio, onOpen, isOpen, onToggle }) => {
  const [abiertoLocal, setAbierto] = useState(false);
  const abierto = isOpen ?? abiertoLocal;
  const panelId = useId();

  return (
    <div className="cambiar-producto">
      <button
        type="button"
        className={["organizer-link", "organizer-module__toggle", abierto ? "is-open" : ""].filter(Boolean).join(" ")}
        aria-expanded={abierto}
        aria-controls={panelId}
        onClick={() => {
          if (!abierto) onOpen?.();
          if (onToggle) onToggle();
          else setAbierto(!abierto);
        }}
      >
        <span className="organizer-link__icon">
          <SidebarIcon src={cambiarIcon} width={24} />
        </span>
        <span className="organizer-module__label">Cambiar</span>
        <SidebarChevron />
      </button>
      <div id={panelId} className="organizer-module__panel" hidden={!abierto}>
        {opcionesPara(negocio).map(({ clave, etiqueta, icono, href }) => (
          <a key={clave} href={href} className="organizer-link organizer-link--sub cambiar-producto__opcion">
            <span className="organizer-link__icon">{icono}</span>
            <span>{etiqueta}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default CambiarProducto;
